import script from "./ChatListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatListItem.vue?vue&type=script&setup=true&lang=ts"

import "./ChatListItem.vue?vue&type=style&index=0&id=2fdf3dd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fdf3dd8"]])

export default __exports__